import type { Image } from '@/lib/api/client'
import { Screenshot } from '@/pages/CADPage/components/ScreenshotPanelButton/Screenshot'
import { Skeleton } from '@/components/ui/skeleton'
import { cn } from '@/utils'

export type ImagesListProps = {
  images: Array<Image | null>
  isLoading: boolean
  isReadOnly: boolean
  isDisabled?: boolean
  onClick: (attrs: {
    image: Image
    event: React.MouseEvent<HTMLImageElement, MouseEvent>
  }) => void
  showName?: boolean
}
export const ImagesList = ({
  images,
  isLoading,
  isReadOnly,
  isDisabled,
  onClick,
  showName,
}: ImagesListProps) => {
  if (isLoading) {
    return (
      <div className="grid grid-cols-3 auto-rows-max gap-4 overflow-y-auto h-full w-full mt-4 pb-16">
        <Skeleton />
        <Skeleton />
        <Skeleton />
      </div>
    )
  }

  if (images.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center space-y-2 mt-10">
        <h1 className="text-md font-semibold text-center">No items found.</h1>
      </div>
    )
  }

  return (
    <div
      className={cn(
        'grid grid-cols-3 auto-rows-max gap-4 overflow-y-auto h-full w-full mt-4 pb-16',
        {
          'pointer-events-none': isDisabled || isLoading,
        },
      )}
    >
      {images
        .filter((image) => !!image)
        .map((view: any, index) => (
          <div key={view.id} className="flex flex-col gap-2">
            {view.loading ? (
              <div className="border rounded-xl p-2 relative w-[230px] h-[250px]">
                <Skeleton className="w-full h-full" />
              </div>
            ) : (
              <Screenshot
                index={index}
                isLoading={isDisabled}
                view={view}
                isReadOnly={isReadOnly}
                onClick={({ event }) => {
                  onClick({ image: view, event })
                }}
              />
            )}
            {showName && (
              <span className="text-xs text-gray-500 self-center">
                {view.name}
              </span>
            )}
          </div>
        ))}
    </div>
  )
}
